import { z } from 'zod';

export const briefRequestSchema = z.object({
  message: z.string().min(10).max(1500),
});
export type BriefRequest = z.infer<typeof briefRequestSchema>;

/** Hasil mentah dari model. Slug dan opsi divalidasi ulang terhadap DB. */
export const briefDraftSchema = z.object({
  productSlug: z.string().min(1).max(80).nullable(),
  selections: z.record(z.string(), z.string()).default({}),
  qty: z.number().int().min(1).max(1_000_000).nullable(),
  notes: z.string().max(500).default(''),
  confidence: z.enum(['high', 'medium', 'low']),
  clarifyingQuestion: z.string().max(300).nullable(),
  reasoning: z.string().max(400).default(''),
});
export type BriefDraft = z.infer<typeof briefDraftSchema>;

/** Jawaban ke klien: sudah diverifikasi terhadap katalog dan mesin harga. */
export const briefResultSchema = z.object({
  status: z.enum(['ready', 'needs_input', 'no_match']),
  productSlug: z.string().nullable(),
  productName: z.string().nullable(),
  selections: z.record(z.string(), z.string()),
  optionLabels: z.array(
    z.object({ key: z.string(), label: z.string(), value: z.string(), valueLabel: z.string() }),
  ),
  qty: z.number().int().nullable(),
  notes: z.string(),
  question: z.string().nullable(),
  missingOptions: z.array(z.string()),
  estimate: z
    .object({ unitPrice: z.number(), total: z.number(), leadTimeDays: z.number() })
    .nullable(),
});
export type BriefResult = z.infer<typeof briefResultSchema>;
